export enum TrackingEvents {
  PRODUCTS_SEARCHED = 'Products Searched',
}
